// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3O0e8","loaderOuter":"PageOverlayLoader_loaderOuter__O4paA"};